import {Epic} from 'redux-observable'
import {filter, mapTo, take} from 'rxjs/operators'
import {bsFetchCollectionAction} from 'module/BSCollection/action/BSCollectionAction'
import {SisName} from 'util/SisName'
import {stTagEnsureRefreshedAction} from 'module/StTag/action/StTagAction'

const StTagEnsureFetchedEpic: Epic = (action$, state$) => action$.pipe(
	filter((action) => bsFetchCollectionAction.match(action) && action.payload.sisName === SisName.StTagZu),
	take(1),
	mapTo(stTagEnsureRefreshedAction()),
)

export const BSStTagZuEpic = StTagEnsureFetchedEpic